/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq3q1Inputs */

const zh_pricing_faq3q1 = /** @type {(inputs: Pricing_Faq3q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年付方案如何计费？`)
};

const en_pricing_faq3q1 = /** @type {(inputs: Pricing_Faq3q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does yearly billing work?`)
};

const es_pricing_faq3q1 = /** @type {(inputs: Pricing_Faq3q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo funciona la facturación anual?`)
};

/**
* | output |
* | --- |
* | "How does yearly billing work?" |
*
* @param {Pricing_Faq3q1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq3q1 = /** @type {((inputs?: Pricing_Faq3q1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq3q1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq3q1(inputs)
	if (locale === "en") return en_pricing_faq3q1(inputs)
	return es_pricing_faq3q1(inputs)
});
export { pricing_faq3q1 as "pricing_faq3Q" }